import styled from '@emotion/styled';
import { TextField } from '@mui/material';

export const Container = styled(TextField)`
  width: initial;
`;
